import { render } from 'inferno';
import App from './app';

import Analytics from './tools/analytics';
import util from './tools/util';

console.log('monp-abt:', process.env.VERSION);

function _onLoad() {
  Analytics.preInit();
  util.setDebugLogger(Analytics.log);
  const element = document.getElementById('react-root');
  render(<App />, element);
}
window.onload = _onLoad;
